import React from 'react';
import { DisableSelectedComponent } from './DisableSelected';
import { EnableSelectedComponent } from './EnableSelected';
import { SearchListComponent } from './SearchList';
import { ToggleAllComponent } from './ToggleAll';

export const ListControlsComponent = ({
  list,
  onSearch,
  searchTerm,
  searchPlaceholder,
  searchName,
  enableSelected,
  disableSelected,
  isSelected,
  toggleAll,
  isDisabled,
  isChecked,
  isFiltered,
}) =>
  !isDisabled || isFiltered ? (
    <div className="access-list-header flex-box-column">
      <SearchListComponent name={searchName} value={searchTerm} placeholder={searchPlaceholder} onSearch={onSearch} />
      <div className="flex-box-row flex-auto">
        <div className="flex-auto">
          <div className="form-row form-row-tight flex-auto">
            {
              <ToggleAllComponent
                toggleAll={toggleAll}
                isDisabled={isDisabled}
                isChecked={isChecked}
                isFiltered={isFiltered}
              />
            }
          </div>
        </div>

        <div className="bulk-selection form-row flex-one">
          <label>{t('label.toggle-selected')}</label>

          <div className="role-selection">
            <div className="role-tags role-tags-compressed">
              {<EnableSelectedComponent isSelected={isSelected} enableSelected={() => enableSelected(list)} />}
              {<DisableSelectedComponent isSelected={isSelected} disableSelected={() => disableSelected(list)} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
